<template>
  <div class="item-tasklist" v-if="!hide_item">
    <el-card
      class="dayplanner-suggestion-card"
      :body-style="{ padding: '0.5em' }"
      :style="goal_duration_today === 0 ? { 'opacity': 0.5 } : {}">
      <div class="dayplanner-suggestion-item">
        <!-- <div style="display: flex; flex-direction: column;" class=""></div>
        <pre>magicTimeslots: {{ magicTimeslots }}</pre>
        <pre>dayplan_remaining_timeslots: {{ dayplan_remaining_timeslots }}</pre>
        view_selected_date_as_yymmdd: {{ view_selected_date_as_yymmdd }} <br />
        view_selected_date_as_timestamp: {{ view_selected_date_as_timestamp }}<br />
        commitmentDailySettings: {{ commitmentDailySettings }}<br />
        goalId: {{ this.goalId }}
        commitmentId: {{ this.commitmentId }}
        -->

        <div style="display: flex;" class="w-100">
          <div class="dayplanner-suggestion-item-image" :style="imageStyle"
            @click="onGoToCommitment()"
            style="cursor: pointer">
            <div style="width: 48px; height: 48px;"></div>
          </div>
          <div style="display: flex; flex-direction: column; justify-content: center;" class="w-100">
            <div class="small-caps-goal-title"
              @click="onGoToCommitment()"
              style="cursor: pointer">
              {{goal_meta.name}} &mdash;
            </div>
            <div
              class="sessions-effort-text"
              style="cursor: pointer"
              @click="onGoToCommitment()">
              {{ name }}
            </div>
            <template v-if="commitment.type === 'TIME_BASED_TASKLIST'">
              <!-- (show progress here) -->
              <!--
              committedTime: 1800000
              committedTimeDaily: 7200
              committedTimePerDay: 7200
              -->
            </template>

            <div class="d-flex w-100" style="justify-content: space-between; align-items: center;">
              <template v-if="!show_more">
                <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  v-if="progress_status && progress_status === 'success'"
                  color='#67C23A' />
                <el-progress
                  v-else
                  :percentage="parseInt( Math.min( 100, progress_percentage ) )"
                  :show-text="false"
                  style="width: 130px;" />
              </template>

              <div style="margin-left: auto; line-height: 8pt; font-size: 9pt;">
                <a href="#" @click.prevent="show_more = !show_more">{{ show_more ? 'hide details' : 'show details' }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hide-during-dayplanner-drop">
        <!-- only show if there is details -->
        <!-- <a href="#" @click.prevent="show_more = !show_more" style="text-align: center; display: block; font-size: 9pt;">{{ show_more ? 'hide details' : 'show details' }}</a> -->
        <template v-if="show_more">
          <div v-if="commitment.committedTimePerDay" class="dayplanner-suggestion-item-text" >
            <div>
              <!--
              <font-awesome-icon
                  :icon="['fas', 'check-circle']"
                  v-if="progress_status && progress_status === 'success'"
                  color='#67C23A'
                  style="margin-right:0.5em" />
              -->
              <!-- You have planned -->
              &#8729;
              <!-- <font-awesome-icon :icon="['fas', 'caret-right']" class="mr-1" /> -->
              <strong>{{ session_duration_today | hoursMinutes }}</strong>
              <template v-if="commitmentDailySettings.committedTimeDaily === 86400  /* MAGIC NUMBER */">.
                <div class="mt-2">
                  <a href="#" @click.prevent="onChangeCommittedTimeDailyForDateTimestamp(120 * 60)">(no daily goal)</a>
                </div>
              </template>
              <template v-else>
                <!-- of your -->
                of
                <duration-quick-settings
                  style="text-decoration: underline; font-weight: bold"
                  :value="commitmentDailySettings.committedTimeDaily || commitment.committedTimePerDay"
                  @save="onChangeCommittedTimeDailyForDateTimestamp($event)"
                  :showSeconds="false"
                  :quickDurationSettings="{
                    /* TODO: presets */
                    '0 min': 0 * 60,
                    '5 min': 5 * 60,
                    '10 min': 10 * 60,
                    '15 min': 15 * 60,
                    '20 min': 20 * 60,
                    '25 min': 25 * 60,
                    '30 min': 30 * 60,
                    '45 min': 45 * 60,
                    '60 min': 60 * 60,
                    '90 min': 90 * 60,
                    '2h': 120 * 60,
                    '3h': 180 * 60,
                    '4h': 240 * 60,
                    '5h': 300 * 60,
                    '6h': 360 * 60,
                    '7h': 420 * 60,
                    '8h': 480 * 60,
                    '9h': 540 * 60,
                    '10h': 600 * 60,
                    '12h': 720 * 60,
                    'no limit': 1440 * 60,
                    'reset': null
                  }" />
                daily target
                <!-- planned today -->
              </template>
            </div>
            <div v-if="this.goal_duration_today !== 0 && commitmentDailySettings.committedTimeDaily !== 86400 /* MAGIC NUMBER */">
              <!--
              <div v-if="progress_status && progress_status !== ''">
                <el-progress
                  :percentage="parseInt( Math.min( 100, progress_percentage ) )"
                  :status="progress_status"
                  :show-text="false"
                  style="width: 250px; margin-right:0px; padding-right: 0px" />
              </div>
              -->
              <!--
              <template v-if="progress_percentage !== null && progress_percentage < 100">
              </template>
              -->
              <el-progress
                :percentage="parseInt( Math.min( 100, progress_percentage ) )"
                :show-text="false"
                style="width: 100px;" />
                <!-- <span style="margin-left: 0.3em">{{ progress_percentage }} %</span> -->
            </div>
          </div>
          <div v-if="commitment.type === 'TIME_BASED_TASKLIST'" class="dayplanner-suggestion-item-text">
            <div>
              &#8729;
              <!-- <font-awesome-icon :icon="['fas', 'caret-right']" class="mr-1" /> -->
              <strong>{{overallTimePlanned|hours}}</strong> of
              <strong>{{commitment.committedTime|hours}}</strong> overall target
              <!-- planned overall -->
            </div>
            <div>
              <!-- TODO: Make overall time editable -->
              <!-- TODO: tsc color? -->
              <el-progress
                :percentage="overallProgressPercentage"
                :show-text="false"
                color="rgb(105, 180, 45)"
                style="width: 100px;" />
            </div>
          </div>
          <div v-if="commitment.endDate.isValid()" class="dayplanner-suggestion-item-text">
            <div>
              &#8729;
              <!-- <font-awesome-icon :icon="['fas', 'caret-right']" class="mr-1" /> -->
              End date
            </div>
            <div>
              {{commitment.endDate|fromNow}} {{/* TODO: from selected date */}}
            </div>
          </div>
        </template>
      </div>
      <!-- <pre class="mini-pre">0:{{commitment}}</pre> -->
      <!-- <pre class="mini-pre">0:{{commitmentId}}</pre> -->
      <!-- <pre class="mini-pre">1:{{commitment.committedTime / 3600}}</pre> -->
      <!-- <pre class="mini-pre">2:{{overallTimePlanned / 3600}}</pre> -->
      <!-- <pre class="mini-pre">3:{{overallProgressPercentage}} %</pre> -->
      <!-- <pre class="mini-pre">4:{{dayplanner_planned_time_overall_by_commitment}}</pre> -->
    </el-card>
    <div
      class="dayplanner-suggestion-caret"
      @mouseover="onMouseoverAddItem('TASKLIST', itemPlacementConfig)"
      @mouseleave="onMouseleaveAddItem"
      >
      <el-button
        size="mini"
        @click="onAddItem({ type: 'TASKLIST' })"
        v-tooltip="{ /* content: 'Add @ 7:20 AM' */ }">
        <!-- TODO: Show smart planning here (popover) instead of header -->
        <font-awesome-icon :icon="['fas', 'chevron-right']" size="lg" />
        <!-- Add -->
      </el-button>
    </div>
  </div>
</template>

<script>
import SuggestionItemMixin from './SuggestionItemMixin.js'

export default {
  mixins: [ SuggestionItemMixin ],
  data() {
    return {
      show_more: false
    }
  },
  props: {
    // See mixin
  },
  computed: {
    // See mixin
    sessionPlacementDuration() {
      if (this.goal_duration_today && this.session_duration_today !== null) {
        return this.goal_duration_today - this.session_duration_today
      } else {
        return 0
      }
    },
    itemPlacementConfig() {
      return {
        duration: this.sessionPlacementDuration, //this.session_duration_today,
        placeAtEnd: false,
        timeslots: this.magicTimeslots.map(item => { return { from: item.from, to: item.to }})
      }
    },
  },
  methods: {
    // See mixin
    onGoToCommitment() {
      this.$router.push("/goal/" + this.goalId + "/kanban");
    }
  }
};
</script>

<style>
/* TODO: See dayplanner.scss */

.item-tasklist {
  margin-top: 0.5em;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: stretch;
}
</style>
